// extracted by mini-css-extract-plugin
export default {"footer":"SHPage_footer__rKPED","footerLogo":"SHPage_footerLogo__M3GYQ","rightColumn":"SHPage_rightColumn__csxzf","map":"SHPage_map__JrvWm"};